module.exports = __webpack_public_path__ + "nr.svg?26db8d7864e0025de14840948c6a70d8";